import { checkColor } from "../../tools"
import useStyles from "./useStyles"

/**
 * Компонент обертка для показа цвета
 * @param {String} color - hex запись цвета
 */
const ColorInformer = ({color}) => {
    const classes = useStyles();
    if(!checkColor(color)) return null
    return <div className={classes.colorBox} style={{backgroundColor:color}}/>
}

export default ColorInformer